import { z } from 'zod';
import { MAX_SESSION_PLAYERS } from '@/config/constants';
import { WinConditionSchema } from './game-definition';
import { TeamScoringTypeSchema } from './team';

// Minimal game configuration persisted with a session (no name/description/ids)

// Helper schema for optional positive numbers that handles NaN from empty inputs
// Accepts NaN from empty number inputs and transforms to undefined
const optionalPositiveNumber = z
  .union([z.number().int().positive(), z.nan()])
  .transform((val): number | undefined => {
    // Convert NaN to undefined, otherwise return the number
    if (Number.isNaN(val)) {
      return undefined;
    }
    return val;
  })
  .optional();

export const GameConfigSchema = z.object({
  hasRounds: z.boolean(),
  winCondition: WinConditionSchema,
  roundTargetPoints: optionalPositiveNumber,
  gameTargetPoints: optionalPositiveNumber,
  targetRounds: optionalPositiveNumber,
  teamScoringType: TeamScoringTypeSchema.optional(),
  maxPlayers: z
    .number()
    .int()
    .positive()
    .max(MAX_SESSION_PLAYERS)
    .default(MAX_SESSION_PLAYERS)
    .optional(),
  version: z.number().int().positive().default(1),
});
export type GameConfig = z.infer<typeof GameConfigSchema>;
